import { FAILED, FILTER, LOADING, SUCCESS } from './constants';
import { initialValues as filterTable } from '../../components/fragments/AreaFilter/fields';

const initialState = {
  dataMerchantList: {
    data: [],
    code: null,
    message: '',
  },
  dataMerchantById: {
    data: null,
    code: null,
    message: '',
  },
  table: {
    filter: { ...filterTable },
  }
};
export default function reducer(state = initialState, action) {
  const { type, data, isLoading, message, filter, key } = action;

  switch (type) {
    case FAILED:
      return {
        ...state,
        [`data${key}`]: data,
        [`isLoading${key}`]: false,
        [`message${key}`]: message,
      };
    case LOADING:
      return {
        ...state,
        [`isLoading${key}`]: isLoading,
        [`message${key}`]: '',
      };
    case SUCCESS:
      // If MerchantList returned a paged response and it's not the first page,
      // append new items to existing list instead of replacing it.
      if (key === 'MerchantList' && data?.meta?.page > 1) {
        const existing = state.dataMerchantList?.data || [];
        return {
          ...state,
          dataMerchantList: {
            ...data,
            data: [...existing, ...(data.data || [])],
          },
          isLoadingMerchantList: false,
          messageMerchantList: message || '',
        };
      }

      return {
        ...state,
        [`data${key}`]: data,
        [`isLoading${key}`]: false,
        [`message${key}`]: message || '',
      };
    case FILTER:
      return {
        ...state,
        [key]: {
          ...state[key],
          filter,
        },
      };
    default:
      return state;
  }
}
